module.exports = __webpack_public_path__ + "img/01.9e1b0435.jpg";